<template>
    <b-dropdown id="btn-values-filters" right dropup no-caret size="sm" class="align-self-center">
        <template slot="button-content">
            <div class="d-flex">
                <div class="mr-2">
                    <i v-if="questionnaires.isLoading" class="fa fa-spinner fa-spin" />
                    <img v-else width="15" height="15" src="@/assets/icons/filters.svg" />
                </div>
                <span>{{ $t('values.filters') }}</span>
            </div>
        </template>
        <b-dropdown-form class="dropdown-form p-3">
            <h5>
                {{ $t('values.filters') }}
            </h5>
            <questionnaires
                applyValuerScope
                :valuerId="user.id"
                :defaultSelecteds="false"
                :model.sync="questionnaires.model"
                @ready="questionnaires.isLoading = false"
            />
            <users :model.sync="evaluateds.model" />
            <networks :model.sync="networks.model" />
            <b-button size="sm" variant="primary" class="float-right" @click="onClickSearch">
                {{ $t('form.button.search') }}
            </b-button>
        </b-dropdown-form>
    </b-dropdown>
</template>
<script>
import Users from './components/Users'
import Networks from './components/Networks'
import { Questionnaires } from '@/views/values/components'

export default {
    components: {
        Users,
        Networks,
        Questionnaires,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            evaluateds: {
                model: [],
            },
            questionnaires: {
                model: [],
                isLoading: true,
            },
            networks: {
                model: [],
            },
        }
    },
    methods: {
        parseFilters() {
            return ['networks', 'evaluateds', 'questionnaires'].reduce((object, key) => {
                return {
                    ...object,
                    [key]: this[key].model.map((i) => i.value),
                }
            }, {})
        },
        onClickSearch() {
            this.$emit('search', this.parseFilters())
        },
    },
    computed: {
        isReady() {
            return !this.evaluateds.isLoading && !this.questionnaires.isLoading
        },
    },
    watch: {
        'questionnaires.isLoading'(newValue) {
            if (!newValue) {
                this.$emit('ready', this.parseFilters())
            }
        },
    },
}
</script>
<style scoped>
.dropdown-form {
    min-width: 500px;
    min-height: 300px;
    max-height: 500px;
    max-width: 600px;
    overflow: auto !important;
}

.font-weight-bold {
    font-weight: 600 !important;
}
</style>
